document.querySelectorAll('.hero__content-wrapper').forEach(wrapper => {
  const stepBlocks = wrapper.querySelectorAll('.shopify-block');

  const validBlocks = Array.from(stepBlocks).filter(block =>
    block.querySelector('.custom_step_box')
  );

  if (validBlocks.length === 0) return;

  // Create wrapper div
  const mainWrapper = document.createElement('div');
  mainWrapper.classList.add('custom_main_content');
  wrapper.replaceWith(mainWrapper);
  mainWrapper.appendChild(wrapper);

  // Move .custom_main_content into .hero__media-wrapper
  const heroContainer = mainWrapper.closest('.hero__container');
  const mediaContainer = heroContainer?.querySelector('.hero__media-wrapper');
  if (mediaContainer) {
    mediaContainer.appendChild(mainWrapper);
  }

  // Create and append .custom_step_boxes
  const customBoxGroup = document.createElement('div');
  customBoxGroup.classList.add('custom_step_boxes');
  validBlocks.forEach(block => customBoxGroup.appendChild(block));
  heroContainer?.appendChild(customBoxGroup);
});



// document.querySelectorAll('.hero__content-wrapper').forEach(wrapper => {
//   const stepBlocks = wrapper.querySelectorAll('.shopify-block');

//   // Filter only those with .custom_step_box inside
//   const validBlocks = Array.from(stepBlocks).filter(block =>
//     block.querySelector('.custom_step_box')
//   );

//   if (validBlocks.length === 0) return;

//   // Create the wrapper div
//   const customBoxGroup = document.createElement('div');
//   customBoxGroup.classList.add('custom_step_boxes');

//   // Move valid blocks into the new group and remove from old location
//   validBlocks.forEach(block => {
//     customBoxGroup.appendChild(block); // move to new wrapper
//   });

//   // Append the new wrapper into the parent .hero__container
//   const heroContainer = wrapper.closest('.hero__container');
//   if (heroContainer) {
//     heroContainer.appendChild(customBoxGroup);
//   }
// });


